(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veyana-footer"]) return;
  try {
    
const topButton = document.querySelector('.vy-back-top');
if (topButton) {
  const updateTopButton = () => { topButton.hidden = window.scrollY < 500; };
  window.addEventListener('scroll', updateTopButton, { passive: true });
  updateTopButton();
  topButton.addEventListener('click', () => {
    window.scrollTo({top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    document.querySelector('.vy-wordmark')?.focus({preventScroll: true});
  });
}

const setExternalLinkTarget = (link) => {
  if (!(link instanceof HTMLAnchorElement)) return;
  const url = new URL(link.href, window.location.href);
  const localHosts = new Set([window.location.hostname, 'getveyana.com', 'www.getveyana.com']);
  if (!['http:', 'https:'].includes(url.protocol) || localHosts.has(url.hostname)) return;
  link.target = '_blank';
  link.relList.add('noopener', 'noreferrer');
};
const updateExternalLinks = (root) => {
  if (root instanceof HTMLAnchorElement) setExternalLinkTarget(root);
  root.querySelectorAll?.('a[href]').forEach(setExternalLinkTarget);
};
updateExternalLinks(document);
new MutationObserver((records) => {
  records.forEach((record) => {
    if (record.type === 'attributes') setExternalLinkTarget(record.target);
    record.addedNodes.forEach(updateExternalLinks);
  });
}).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veyana-header"]) return;
  try {
    
import('@shopify/events').then(({StandardEvents})=>document.addEventListener(StandardEvents.cartLinesUpdate,event=>{event.promise?.then(({cart,detail})=>{const count=cart?.totalQuantity??detail?.itemCount;if(count!==undefined)document.querySelectorAll('.vy-bag').forEach(bag=>{bag.querySelector('span').textContent=String(count);bag.setAttribute('aria-label',`Shopping cart, ${count} items`);});}).catch(()=>{});})).catch(()=>{});
document.querySelectorAll('.vy-mobile-menu').forEach(menu=>{menu.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>menu.removeAttribute('open')));menu.addEventListener('keydown',e=>{if(e.key==='Escape'){menu.removeAttribute('open');menu.querySelector('summary').focus();}});document.addEventListener('click',e=>{if(!menu.contains(e.target))menu.removeAttribute('open');});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veyana-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ve-ingredient-list details').forEach(item=>item.addEventListener('toggle',()=>{if(item.open){item.parentElement.querySelectorAll('details').forEach(other=>{if(other!==item)other.open=false;});}}));

(() => {
 const init = () => document.querySelectorAll('.ve-values-stage').forEach(stage => {
  if(stage.dataset.scrollReady) return;
  stage.dataset.scrollReady='true';
  const section=stage.closest('.ve-values'), viewport=stage.querySelector('.ve-values-viewport'), track=stage.querySelector('.ve-values-scroll');
  const mobile=matchMedia('(max-width:700px)'), motion=matchMedia('(prefers-reduced-motion:reduce)');
  let enabled=false,distance=0,top=0,frame=0,scroller=window;
  const scrollPosition=()=>scroller===window?window.scrollY:scroller.scrollTop;
  const paint=()=>{frame=0;if(!enabled)return;const progress=Math.max(0,Math.min(distance,top-stage.getBoundingClientRect().top));track.style.transform=`translate3d(${-progress}px,0,0)`;};
  const queue=()=>{if(!frame)frame=requestAnimationFrame(paint);};
  const measure=()=>{
   scroller=window;
   for(let parent=stage.parentElement;parent&&parent!==document.body;parent=parent.parentElement){
    if(/auto|scroll/.test(getComputedStyle(parent).overflowY)&&parent.scrollHeight>parent.clientHeight){scroller=parent;break;}
   }
   enabled=!motion.matches&&innerHeight>=600;
   section.classList.toggle('ve-scroll-pinned',enabled);
   stage.style.height='';track.style.transform='';
   if(!enabled)return;
   top=(document.querySelector('#header-group')?.getBoundingClientRect().height||0)+12;
   section.style.setProperty('--ve-pin-top',`${top}px`);
   section.style.setProperty('--ve-photo-height',`${Math.max(150,Math.min(340,innerHeight-top-370))}px`);
   track.scrollLeft=0;
   distance=Math.max(0,track.scrollWidth-viewport.clientWidth);
   if(distance<=1){enabled=false;section.classList.remove('ve-scroll-pinned');return;}
   const endHold=Math.max(320,Math.round(innerHeight*0.65));
   stage.style.height=`${viewport.offsetHeight+distance+endHold}px`;
   paint();
  };
  track.addEventListener('keydown',event=>{
   if(!enabled||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
   event.preventDefault();const start=scrollPosition()+stage.getBoundingClientRect().top-top;
   const current=Math.max(0,Math.min(distance,scrollPosition()-start));
   const step=track.querySelector('article').offsetWidth+22;
   const target=event.key==='Home'?0:event.key==='End'?distance:current+(event.key==='ArrowRight'?step:-step);
   scroller.scrollTo({top:start+Math.max(0,Math.min(distance,target)),behavior:'auto'});
  });
  track.addEventListener('focusin',event=>{if(!enabled)return;const card=event.target.closest('article');if(card){const start=scrollPosition()+stage.getBoundingClientRect().top-top;scroller.scrollTo({top:start+Math.min(distance,card.offsetLeft-track.offsetLeft),behavior:'auto'});}});
  document.addEventListener('scroll',queue,{passive:true,capture:true});
  window.addEventListener('resize',measure,{passive:true});
  mobile.addEventListener('change',measure);motion.addEventListener('change',measure);
  track.querySelectorAll('img').forEach(image=>image.addEventListener('load',measure,{once:true}));
  document.fonts?.ready.then(measure);measure();
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veyana-product"]) return;
  try {
    
document.querySelectorAll('[data-vy-step]').forEach(button=>button.addEventListener('click',()=>{const input=button.parentElement.querySelector('input');const step=Number(button.dataset.vyStep);input.value=String(Math.max(1,(parseInt(input.value,10)||1)+step));input.dispatchEvent(new Event('change',{bubbles:true}));}));

  } catch(e) { console.error(e); }
})();
})();
